/**
 * Generated by orval v7.2.0 🍺
 * Do not edit manually.
 * BVHI Product Data Platform
 * The backend service api is responsible for managing users, customer data, product catalogs, and api token.
 * OpenAPI spec version: 1.28.12
 */
import { useQuery, useSuspenseQuery } from "@tanstack/react-query";
import type {
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from "@tanstack/react-query";
import type {
  BadRequestResponse,
  ForbiddenResponse,
  InternalServerErrorResponse,
  OrganisationDTO,
  PaginatedActiveSupplierListItemsDTO,
  TooManyRequestsResponse,
  UnauthorizedResponse,
} from "../../model";
import { customFetchInstance } from "../../../custom-fetch-instance";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];

/**
 * Returns a paginated list of all active suppliers on HIDataSync.

 * @summary Get list of all active suppliers
 */
export type getActiveSuppliersResponse = {
  data: PaginatedActiveSupplierListItemsDTO;
  status: number;
};

export const getGetActiveSuppliersUrl = () => {
  return `http://localhost:8080/api/v1/suppliers`;
};

export const getActiveSuppliers = async (
  options?: RequestInit
): Promise<getActiveSuppliersResponse> => {
  return customFetchInstance<Promise<getActiveSuppliersResponse>>(
    getGetActiveSuppliersUrl(),
    {
      ...options,
      method: "GET",
    }
  );
};

export const getGetActiveSuppliersQueryKey = () => {
  return [`http://localhost:8080/api/v1/suppliers`] as const;
};

export const getGetActiveSuppliersQueryOptions = <
  TData = Awaited<ReturnType<typeof getActiveSuppliers>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | TooManyRequestsResponse
    | InternalServerErrorResponse,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getActiveSuppliers>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetActiveSuppliersQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getActiveSuppliers>>
  > = ({ signal }) => getActiveSuppliers({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getActiveSuppliers>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetActiveSuppliersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getActiveSuppliers>>
>;
export type GetActiveSuppliersQueryError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | TooManyRequestsResponse
  | InternalServerErrorResponse;

export function useGetActiveSuppliers<
  TData = Awaited<ReturnType<typeof getActiveSuppliers>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | TooManyRequestsResponse
    | InternalServerErrorResponse,
>(options: {
  query: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getActiveSuppliers>>,
      TError,
      TData
    >
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof getActiveSuppliers>>,
        TError,
        TData
      >,
      "initialData"
    >;
  request?: SecondParameter<typeof customFetchInstance>;
}): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetActiveSuppliers<
  TData = Awaited<ReturnType<typeof getActiveSuppliers>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | TooManyRequestsResponse
    | InternalServerErrorResponse,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getActiveSuppliers>>,
      TError,
      TData
    >
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof getActiveSuppliers>>,
        TError,
        TData
      >,
      "initialData"
    >;
  request?: SecondParameter<typeof customFetchInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetActiveSuppliers<
  TData = Awaited<ReturnType<typeof getActiveSuppliers>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | TooManyRequestsResponse
    | InternalServerErrorResponse,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getActiveSuppliers>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Get list of all active suppliers
 */

export function useGetActiveSuppliers<
  TData = Awaited<ReturnType<typeof getActiveSuppliers>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | TooManyRequestsResponse
    | InternalServerErrorResponse,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getActiveSuppliers>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetActiveSuppliersQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetActiveSuppliersSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getActiveSuppliers>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | TooManyRequestsResponse
    | InternalServerErrorResponse,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof getActiveSuppliers>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetActiveSuppliersQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getActiveSuppliers>>
  > = ({ signal }) => getActiveSuppliers({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getActiveSuppliers>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetActiveSuppliersSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getActiveSuppliers>>
>;
export type GetActiveSuppliersSuspenseQueryError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | TooManyRequestsResponse
  | InternalServerErrorResponse;

export function useGetActiveSuppliersSuspense<
  TData = Awaited<ReturnType<typeof getActiveSuppliers>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | TooManyRequestsResponse
    | InternalServerErrorResponse,
>(options: {
  query: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof getActiveSuppliers>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetActiveSuppliersSuspense<
  TData = Awaited<ReturnType<typeof getActiveSuppliers>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | TooManyRequestsResponse
    | InternalServerErrorResponse,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof getActiveSuppliers>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetActiveSuppliersSuspense<
  TData = Awaited<ReturnType<typeof getActiveSuppliers>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | TooManyRequestsResponse
    | InternalServerErrorResponse,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof getActiveSuppliers>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Get list of all active suppliers
 */

export function useGetActiveSuppliersSuspense<
  TData = Awaited<ReturnType<typeof getActiveSuppliers>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | TooManyRequestsResponse
    | InternalServerErrorResponse,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof getActiveSuppliers>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customFetchInstance>;
}): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetActiveSuppliersSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns a list of all suppliers connected the chainnumbers to the given audiologist
 * @summary Get suppliers of an audiologist
 */
export type getSuppliersOfAudiologistResponse = {
  data: OrganisationDTO[];
  status: number;
};

export const getGetSuppliersOfAudiologistUrl = (audiologistId: string) => {
  return `http://localhost:8080/platform/v1/audiologists/${audiologistId}/suppliers`;
};

export const getSuppliersOfAudiologist = async (
  audiologistId: string,
  options?: RequestInit
): Promise<getSuppliersOfAudiologistResponse> => {
  return customFetchInstance<Promise<getSuppliersOfAudiologistResponse>>(
    getGetSuppliersOfAudiologistUrl(audiologistId),
    {
      ...options,
      method: "GET",
    }
  );
};

export const getGetSuppliersOfAudiologistQueryKey = (audiologistId: string) => {
  return [
    `http://localhost:8080/platform/v1/audiologists/${audiologistId}/suppliers`,
  ] as const;
};

export const getGetSuppliersOfAudiologistQueryOptions = <
  TData = Awaited<ReturnType<typeof getSuppliersOfAudiologist>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  audiologistId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSuppliersOfAudiologist>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetSuppliersOfAudiologistQueryKey(audiologistId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSuppliersOfAudiologist>>
  > = ({ signal }) =>
    getSuppliersOfAudiologist(audiologistId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!audiologistId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getSuppliersOfAudiologist>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSuppliersOfAudiologistQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSuppliersOfAudiologist>>
>;
export type GetSuppliersOfAudiologistQueryError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | InternalServerErrorResponse;

export function useGetSuppliersOfAudiologist<
  TData = Awaited<ReturnType<typeof getSuppliersOfAudiologist>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  audiologistId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSuppliersOfAudiologist>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuppliersOfAudiologist>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetSuppliersOfAudiologist<
  TData = Awaited<ReturnType<typeof getSuppliersOfAudiologist>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  audiologistId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSuppliersOfAudiologist>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuppliersOfAudiologist>>,
          TError,
          TData
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetSuppliersOfAudiologist<
  TData = Awaited<ReturnType<typeof getSuppliersOfAudiologist>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  audiologistId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSuppliersOfAudiologist>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Get suppliers of an audiologist
 */

export function useGetSuppliersOfAudiologist<
  TData = Awaited<ReturnType<typeof getSuppliersOfAudiologist>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  audiologistId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSuppliersOfAudiologist>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetSuppliersOfAudiologistQueryOptions(
    audiologistId,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetSuppliersOfAudiologistSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getSuppliersOfAudiologist>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  audiologistId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getSuppliersOfAudiologist>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetSuppliersOfAudiologistQueryKey(audiologistId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSuppliersOfAudiologist>>
  > = ({ signal }) =>
    getSuppliersOfAudiologist(audiologistId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!audiologistId,
    ...queryOptions,
  } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getSuppliersOfAudiologist>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSuppliersOfAudiologistSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSuppliersOfAudiologist>>
>;
export type GetSuppliersOfAudiologistSuspenseQueryError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | InternalServerErrorResponse;

export function useGetSuppliersOfAudiologistSuspense<
  TData = Awaited<ReturnType<typeof getSuppliersOfAudiologist>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  audiologistId: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getSuppliersOfAudiologist>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetSuppliersOfAudiologistSuspense<
  TData = Awaited<ReturnType<typeof getSuppliersOfAudiologist>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  audiologistId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getSuppliersOfAudiologist>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useGetSuppliersOfAudiologistSuspense<
  TData = Awaited<ReturnType<typeof getSuppliersOfAudiologist>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  audiologistId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getSuppliersOfAudiologist>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Get suppliers of an audiologist
 */

export function useGetSuppliersOfAudiologistSuspense<
  TData = Awaited<ReturnType<typeof getSuppliersOfAudiologist>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
>(
  audiologistId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getSuppliersOfAudiologist>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customFetchInstance>;
  }
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetSuppliersOfAudiologistSuspenseQueryOptions(
    audiologistId,
    options
  );

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}
